module.exports = __webpack_public_path__ + "img/05a_Buy_Persona.15da72c5.jpg";